/**
 * @generated SignedSource<<1152c9de046818310bee8341fec3de17>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime'
import { FragmentRefs } from 'relay-runtime'
export type ShortCodeContextProvider_postFragment$data = {
  readonly items: ReadonlyArray<{
    readonly slug: string
    readonly image: {
      readonly alt: string | null
      readonly url: string
    } | null
    readonly h1: string
    readonly meta_description: string | null
  }>
  readonly ' $fragmentType': 'ShortCodeContextProvider_postFragment'
}
export type ShortCodeContextProvider_postFragment$key = {
  readonly ' $data'?: ShortCodeContextProvider_postFragment$data
  readonly ' $fragmentSpreads': FragmentRefs<'ShortCodeContextProvider_postFragment'>
}

const node: ReaderFragment = {
  argumentDefinitions: [],
  kind: 'Fragment',
  metadata: null,
  name: 'ShortCodeContextProvider_postFragment',
  selections: [
    {
      alias: null,
      args: null,
      concreteType: 'Post',
      kind: 'LinkedField',
      name: 'items',
      plural: true,
      selections: [
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'slug',
          storageKey: null
        },
        {
          alias: null,
          args: null,
          concreteType: 'PostImage',
          kind: 'LinkedField',
          name: 'image',
          plural: false,
          selections: [
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'alt',
              storageKey: null
            },
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'url',
              storageKey: null
            }
          ],
          storageKey: null
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'h1',
          storageKey: null
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'meta_description',
          storageKey: null
        }
      ],
      storageKey: null
    }
  ],
  type: 'PostResult',
  abstractKey: null
}

;(node as any).hash = '0cb5f7acb7c812e5cef002cdc28db692'

export default node
